import { useMutation, useQueryClient } from '@tanstack/react-query';

import { enderecoDeArquivo } from '@/shared/api/client';
import { brokerQuotes, type BrokerDraftFile } from '@/shared/api/resources';
import { useToast } from '@/shared/ui/useToast';

/**
 * "Imprimir minuta" da corretora (decisao do dono de 04/11/2026; ADR 0108).
 *
 * A minuta sai na hora, do modelo ligado a modalidade, pelo mesmo motor da seguradora,
 * e chega so em PDF, com "SEM VALOR" em cada pagina. A vigente em assinatura e entregue
 * como esta, sem gerar outra.
 *
 * O PDF e baixado pelo endereco temporario, na propria aba: o armazenamento responde o
 * arquivo como anexo, com o nome que o servidor deu, e a tela continua onde esta. Abrir
 * uma janela nova seria barrado como janela nao pedida, porque a geracao e a conversao
 * levam alguns segundos depois do clique.
 */
export function baixarPdfDaMinuta(arquivo: BrokerDraftFile): void {
  const ancora = document.createElement('a');
  ancora.href = enderecoDeArquivo(arquivo.url);
  ancora.download = arquivo.filename;
  ancora.rel = 'noopener';
  document.body.append(ancora);
  ancora.click();
  ancora.remove();
}

/** Gera e baixa a minuta da cotacao, com o aviso de progresso e o resultado. */
export function useImprimirMinuta() {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (operacao: { id: string; numero: string }) => {
      const arquivo = await brokerQuotes.draft(operacao.id);
      baixarPdfDaMinuta(arquivo);
      return arquivo;
    },
    onMutate: (operacao) =>
      toast.info(
        `Gerando a minuta da cotacao ${operacao.numero}. O PDF baixa em seguida.`,
      ),
    onSuccess: (arquivo, operacao) => {
      toast.success(
        arquivo.in_signature
          ? `A minuta ${arquivo.number} esta em assinatura e foi baixada como esta.`
          : `Minuta ${arquivo.number} gerada.`,
      );
      void queryClient.invalidateQueries({ queryKey: ['quote-timeline', operacao.id] });
    },
    onError: (error: Error) => toast.error(error.message),
  });
}
